
export default function Header({ isMenuOpen, setIsMenuOpen }: { isMenuOpen: boolean; setIsMenuOpen: (value: boolean) => void }) {
  const scrollToSection = (id: string) => {
    setIsMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-md z-50">
      <div className="w-full px-6">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/33059925aedb8e7ecebe0f38d6820964/5b68232d399265631754919c6935f83b.png" 
              alt="TOKAN補助金コンサルタント" 
              className="w-12 h-12 object-contain"
            />
            <div>
              <h1 className="font-bold text-xl text-gray-900">TOKAN</h1>
              <p className="text-xs text-gray-600">補助金コンサルタント</p>
            </div>
          </div>

          <nav className="hidden lg:flex items-center gap-8">
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-blue-900 font-medium transition-colors cursor-pointer whitespace-nowrap">
              サービス内容
            </button>
            <button onClick={() => scrollToSection('pricing')} className="text-gray-700 hover:text-blue-900 font-medium transition-colors cursor-pointer whitespace-nowrap">
              料金プラン
            </button>
            <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-blue-900 font-medium transition-colors cursor-pointer whitespace-nowrap">
              よくある質問
            </button>
            <button onClick={() => scrollToSection('contact')} className="bg-gradient-to-r from-blue-900 to-blue-700 text-white px-6 py-3 rounded-lg font-bold hover:shadow-lg transition-all cursor-pointer whitespace-nowrap">
              無料相談はこちら
            </button>
          </nav>

          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-blue-900 transition-colors cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <nav className="px-6 py-4 space-y-3">
            <button onClick={() => scrollToSection('services')} className="block w-full text-left py-2 text-gray-700 hover:text-blue-900 font-medium transition-colors cursor-pointer">
              サービス内容
            </button>
            <button onClick={() => scrollToSection('pricing')} className="block w-full text-left py-2 text-gray-700 hover:text-blue-900 font-medium transition-colors cursor-pointer">
              料金プラン
            </button>
            <button onClick={() => scrollToSection('faq')} className="block w-full text-left py-2 text-gray-700 hover:text-blue-900 font-medium transition-colors cursor-pointer">
              よくある質問
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-center bg-gradient-to-r from-blue-900 to-blue-700 text-white px-6 py-3 rounded-lg font-bold hover:shadow-lg transition-all cursor-pointer whitespace-nowrap">
              無料相談はこちら
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
